import axios from 'axios';

const apiAnalytics = axios.create({
  baseURL: `${process.env.REACT_APP_ANALYTICS_API}`
});

apiAnalytics.interceptors.request.use(async (config) => {
  const token = localStorage.tolkenINSV;

  if (token) {
    config.headers.authorization = `${token}`;
  }

  return config;
});

apiAnalytics.interceptors.response.use(
  (response) => {
    return response;
  },

  (err) => Promise.reject(err)
);

export default apiAnalytics;